import { render, staticRenderFns } from "./setGame3.vue?vue&type=template&id=96f1af44&"
import script from "./setGame3.vue?vue&type=script&lang=js&"
export * from "./setGame3.vue?vue&type=script&lang=js&"
import style0 from "./setGame3.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports